import api from './utilPartner';

const controller = 'PessoaBanco';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarReferenciaBancariaPorPessoa: function (dto) {
    return api.Axios.GetParams(url + '/ListarReferenciaBancariaPorPessoa', dto);
  }
});
